import { initializeApp } from "firebase/app";
import { getMessaging, isSupported, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCB895wEOHJLHH9m2p3qrn9r7_6RQ1WAi4",
  authDomain: "mf-theramynd-dev.firebaseapp.com",
  projectId: "mf-theramynd-dev",
  storageBucket: "mf-theramynd-dev.appspot.com",
  messagingSenderId: "17129051079",
  appId: "1:17129051079:web:2a12bedb0fa04f9845bfe2",
  measurementId: "G-HMRH8W9RKC",
};

export const messagingKey =
  "BFa9RE0uqQQydOkytNcsCP31ZqxWxK4RN1LNeXSIy2hJ-hOKszGlhmzLRVt4kD_qMMtByWYJuZxOjpL8mTQmwdU";
export let messaging = {};

const initializeFirebase = async () => {
  const isMessagingSupported = await isSupported();

  if (isMessagingSupported) {
    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);

    // Request permission when the script loads or when the user interacts with the page
    if (!!navigator.serviceWorker) {
      Notification.requestPermission().then((permission) => {
        console.log("Notification permission:", permission);
      });

      // Example: Listen for messages when the app is in the foreground
      onMessage(messaging, (payload) => {
        console.log("Message received:", payload);
        // Handle the incoming message as needed
      });
    }
  }

  return isMessagingSupported;
};

// Call the initialization function
export const isMessgingSupported = initializeFirebase();
